import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const SkipLinkContainer = styled(motion.a)`
  position: absolute;
  top: -100px;
  left: 0;
  z-index: 10000;
  padding: 12px 24px;
  background: #1d334e;
  color: #ffffff;
  text-decoration: none;
  font-weight: 600;
  font-size: 16px;
  border-radius: 0 0 8px 0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  transition: top 0.3s ease;

  &:focus {
    top: 0;
    outline: 3px solid #BF1922;
    outline-offset: 2px;
  }

  &:hover {
    background: #BF1922;
  }
`;

/**
 * SkipLink Component
 * Provides a skip-to-main-content link for keyboard navigation and screen readers
 * Only visible when focused (keyboard navigation)
 */
const SkipLink = () => {
  const handleClick = (e) => {
    e.preventDefault();
    const mainContent = document.querySelector('main[role="main"]');
    if (mainContent) {
      mainContent.focus();
      mainContent.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <SkipLinkContainer
      href="#main-content"
      onClick={handleClick}
      aria-label="Skip to main content"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.2 }}
    >
      Skip to main content
    </SkipLinkContainer>
  );
};

export default SkipLink;
